<template>
  <div
    class="col col-12 vert-align"
    :style="{ 'padding-left': isHorizontal ? '0' : '5px!important' }"
  >
    <div
      class="row f-row vert-align"
      style="font-size: 0.8rem!important; height: 1rem!important;"
    >
      <div
        class="col vert-align"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
        :style="{
          'padding-right': !isHorizontal ? '2px!important;' : '0',
        }"
      >
        <button
          class="btn detailView"
          :class="{ active: showBudget, 'vertical-btn': !isHorizontal }"
          v-on:click="onShow(4)"
        >
          Budget
          <i
            class="fa fa-minus"
            style="color:var(--dark-expo)"
            v-if="showBudget"
          ></i>
          <i class="fa fa-minus" style="color:var(--textinactive)" v-else></i>
        </button>
      </div>

      <div :class="{ 'w-100': !isHorizontal }"></div>
      <div
        class="col vert-align"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <button
          class="btn detailView"
          :class="{ active: showExpo, 'vertical-btn': !isHorizontal }"
          v-on:click="onShow(1)"
        >
          <span class="button-label">Reforecast</span>

          <span class="button-symbol">
            <div
              style="margin-right: 7px;"
              v-bind:class="[
                showExpo ? 'square-border-expo' : 'square-border-expo-off',
              ]"
            ></div>
          </span>
        </button>
      </div>

      <div :class="{ 'w-100': !isHorizontal }"></div>
      <div
        class="col vert-align"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <button
          class="btn detailView"
          :class="{ active: showBasisRatio, 'vertical-btn': !isHorizontal }"
          v-on:click="onShow(11)"
        >
          <span class="button-label">Commited</span>

          <span class="button-symbol">
            <div
              style="margin-right: 7px;"
              v-bind:class="[
                showBasisRatio
                  ? 'square-border-hedge'
                  : 'square-border-hedge-off',
              ]"
            ></div>
          </span>
        </button>
      </div>

      <template v-if="!isAdvanced">
        <div :class="{ 'w-100': !isHorizontal }"></div>
        <div
          class="col"
          :style="
            isHorizontal
              ? { 'padding-left': '12px!important' }
              : { 'padding-right': '8px!important' }
          "
          v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
        >
          <label
            :for="'showHedgeDetails'"
            class="toggle__button vert-align"
            :class="{ active: showFixedHedged }"
          >
            <input
              type="checkbox"
              v-on:click="onShow(16)"
              :id="'showHedgeDetails'"
            />

            <span :class="{ active: showFixedHedged }">
              Hedge details
            </span>

            <span class="toggle__switch"></span>
          </label>
        </div>
      </template>

      <div :class="{ 'w-100': !isHorizontal }"></div>
      <div
        class="col vert-align"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <button
          class="btn detailView"
          :class="{ active: showHedge, 'vertical-btn': !isHorizontal }"
          :style="
            !isAdvanced && !isHorizontal
              ? { 'padding-left': '7px!important' }
              : {}
          "
          v-on:click="onShow(2)"
        >
          <span class="button-label">{{
            showFixedHedged ? "Fixed" : "Hedged"
          }}</span>

          <span class="button-symbol">
            <div
              style="margin-right: 7px;"
              v-bind:class="[
                showHedge
                  ? 'square-border-dark-fwd'
                  : 'square-border-dark-fwd-off',
              ]"
            ></div>
          </span>
        </button>
      </div>

      <div v-if="showFixedHedged" :class="{ 'w-100': !isHorizontal }"></div>
      <div
        v-if="showFixedHedged"
        class="col vert-align"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <button
          class="btn detailView"
          :class="{ active: showProtected, 'vertical-btn': !isHorizontal }"
          :style="
            isAdvanced && isHorizontal
              ? {}
              : { 'padding-left': '7px!important' }
          "
          v-on:click="onShow(15)"
        >
          <span class="button-label">Options</span>

          <span class="button-symbol">
            <div
              style="margin-right: 7px;"
              v-bind:class="[
                isAdvanced
                  ? showProtected
                    ? 'square-border-dark-fwd'
                    : 'square-border-dark-fwd-off'
                  : showProtected
                  ? 'square-border-dark-hed'
                  : 'square-border-dark-hed-off',
              ]"
            ></div>
          </span>
        </button>
      </div>

      <div :class="{ 'w-100': !isHorizontal }"></div>
      <div
        class="col vert-align"
        v-show="false"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <button
          class="btn detailView"
          :class="{ active: showHedge, 'vertical-btn': !isHorizontal }"
          v-on:click="onShow(2)"
          style="padding-left: 8px !important; padding-right: 2px!important;"
        >
          <span class="txt-label-primary align-middle">Last&nbsp;</span>
          <div
            v-bind:class="[
              showHedge
                ? 'square-border-dark-fwd'
                : 'square-border-dark-fwd-off',
            ]"
          ></div>
        </button>
      </div>
      <!-- <div :class="{ 'w-100': !isHorizontal }"></div>
      <div
        class="col vert-align"
        v-show="false"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <select
          class="dropdown-form dropdown-analysis"
          v-model="selectedExecutionTimeAux"
          @change="onUserSelectedExecutionTime"
        >
          <option>Week</option>
          <option>2 weeks</option>
          <option>Month</option>
        </select>
      </div>
      <div :class="{ 'w-100': !isHorizontal }"></div> -->
      <!-- <div
        class="col vert-align"
        v-show="false"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <button
          class="btn detailView"
          :class="{ active: showRequired }"
          v-on:click="onShowRequired"
          style="padding-left: 8px !important; padding-right: 2px!important;"
        >
          <div
            v-bind:class="[
              showRequired ? 'square-border-gray' : 'square-border-gray-off',
            ]"
          ></div>
        </button>
        <span class="align-middle">Required</span>
      </div> -->
      <div :class="{ 'w-100': !isHorizontal }"></div>
      <div
        class="col vert-align"
        v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
      >
        <button
          class="btn detailView"
          :class="{ active: showProgram, 'vertical-btn': !isHorizontal }"
          v-on:click="onShowProgram"
        >
          Program
          <i
            class="fa fa-minus"
            style="color:var(--program)"
            v-if="showProgram"
          ></i>
          <i class="fa fa-minus" style="color:var(--textinactive)" v-else></i>
        </button>
      </div>

      <template v-if="isAdvanced">
        <div :class="{ 'w-100': !isHorizontal }"></div>
        <div
          class="col"
          :style="
            isHorizontal
              ? {
                  'padding-left': '12px!important',
                  'padding-right': '15px!important',
                }
              : { 'padding-right': '8px!important' }
          "
          v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
        >
          <label
            :for="normalizePlanning"
            class="toggle__button vert-align"
            :class="{ active: normalizePlanning }"
          >
            <input
              type="checkbox"
              v-on:click="onNormalizePlanning"
              :id="normalizePlanning"
            />
            <span :class="{ active: normalizePlanning }">{{
              normalizePlanning ? "Normalize On" : "Normalize Off"
            }}</span>
            <span class="toggle__switch"></span>
          </label>
        </div>

        <div :class="{ 'w-100': !isHorizontal }"></div>
        <div
          class="col vert-align"
          v-bind:class="[isHorizontal ? 'col-2' : 'col-12']"
          :style="
            isHorizontal
              ? {
                  'padding-left': '5px !important;',
                  'padding-right': '5px!important;',
                }
              : {}
          "
        >
          <RangeSlider
            :dates="xRange.length > 1 ? xRange.slice(0, -1) : xRange"
            :labelTxt="'Zoom:'"
            :maxIdx="zoomFinal"
            :minIdx="zoomInitial"
            :showDates="showDates"
            @eventOnMinRange="eventMinRange"
            @eventOnMaxRange="eventMaxRange"
            @eventOnMinRangeChange="eventMinRangeChange"
            @eventOnMaxRangeChange="eventMaxRangeChange"
          />
        </div>
        <div :class="{ 'w-100': !isHorizontal }"></div>
        <div
          class="col vert-align justify-content-start"
          v-bind:class="[isHorizontal ? 'col-auto' : 'col-6']"
          style="padding-left: 4px !important; padding-right: 4px!important;"
        >
          <button
            :disabled="zoomInitial === 0"
            class="btn detailView"
            v-on:click="onUserZoom(1)"
          >
            <i class="fa fa-chevron-left"></i>
          </button>
          <button
            :disabled="zoomInitial + 1 === zoomFinal"
            class="btn detailView"
            v-on:click="onUserZoom(2)"
          >
            <i class="fa fa-chevron-right"></i>
          </button>
        </div>
        <div
          v-if="isHorizontal"
          class="col vert-align justify-content-center"
          v-bind:class="[isHorizontal ? 'col-fixed' : 'col-12']"
          style="padding-left: 4px !important; padding-right: 4px!important;"
        >
          {{ chartDateRange }}
        </div>
        <div
          class="col vert-align justify-content-end"
          v-bind:class="[isHorizontal ? 'col-auto' : 'col-6']"
          style="padding-left: 4px !important; padding-right: 8px!important;"
        >
          <button
            :disabled="zoomInitial + 1 === zoomFinal"
            class="btn detailView"
            v-on:click="onUserZoom(3)"
          >
            <i class="fa fa-chevron-left"></i>
          </button>
          <button
            :disabled="zoomFinal + 2 === xRange.length"
            class="btn detailView"
            v-on:click="onUserZoom(4)"
          >
            <i class="fa fa-chevron-right"></i>
          </button>
        </div>
        <div :class="{ 'w-100': !isHorizontal }"></div>
        <div
          v-if="!isHorizontal"
          class="col vert-align justify-content-center"
          v-bind:class="[isHorizontal ? 'col-auto' : 'col-12']"
          style="padding-left: 4px !important; padding-right: 4px!important;"
        >
          {{ chartDateRange }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import RangeSlider from "@/components/analytics/RangeSlider.vue";
import { dateRangeToString } from "@/_core/_helpers/_helpers";
import { timeFormat } from "d3";

export default {
  name: "PlanningSelectors",
  components: {
    RangeSlider,
  },
  props: {
    asset: { required: false, default: "currencies" },
    executeVolatility: { required: false, type: Boolean, default: false },
    expandFRow: { required: true },
    fixing_type: { required: false, default: "basis" },
    isAdvanced: { required: false, type: Boolean, default: true },
    isHorizontal: { required: false, type: Boolean, default: true },
    normalizePlanning: { required: true },
    selectedExecutionTime: { required: true },
    showBudget: { required: false, type: Boolean, default: false },
    showBasisRatio: { required: true },
    showDates: { required: false, type: Boolean, default: true },
    showExpo: { required: true },
    showFixedHedged: { required: false, type: Boolean, default: false },
    showHedge: { required: true },
    showProgram: { required: true },
    showProtected: { required: false, type: Boolean, default: false },
    showRequired: { required: true },
    xRange: { required: true },
    zoomFinal: { required: true },
    zoomInitial: { required: true },
  },
  data() {
    return {
      debounceTimeout: null,
      selectedExecutionTimeAux: "",
    };
  },
  mounted() {
    this.selectedExecutionTimeAux = this.selectedExecutionTime;
  },
  computed: {
    chartDateRange() {
      if (this.xRange.length === 0) {
        return timeFormat("%b %d, %Y")(new Date());
      } else {
        try {
          return dateRangeToString(
            this.xRange[this.zoomInitial],
            this.xRange[this.zoomFinal - 1],
            true,
            " \u2192 ",
          );
        } catch {
          return "none";
        }
      }
    },
  },
  methods: {
    onShow(val) {
      this.$emit("eventOnShow", val);
    },
    onShowRequired() {
      this.$emit("eventOnShowRequired");
    },
    onShowProgram() {
      this.$emit("eventOnShowProgram");
    },
    onNormalizePlanning() {
      this.$emit("eventOnNormalizePlanning");
    },
    onUserZoom(val) {
      if (val == 1) {
        this.eventMinRange(this.zoomInitial - 1);
      } else if (val == 2) {
        this.eventMinRange(this.zoomInitial + 1);
      } else if (val == 3) {
        this.eventMaxRange(this.zoomFinal - 1);
      } else if (val == 4) {
        this.eventMaxRange(this.zoomFinal + 1);
      }

      // reset timer for second action
      if (this.executeVolatility) {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
          if (val == 1) {
            this.eventMinRangeChange(this.zoomInitial - 1);
          } else if (val == 2) {
            this.eventMinRangeChange(this.zoomInitial + 1);
          } else if (val == 3) {
            this.eventMaxRangeChange(this.zoomFinal - 1);
          } else if (val == 4) {
            this.eventMaxRangeChange(this.zoomFinal + 1);
          }
        }, 1000);
      }
    },
    eventMinRange(val) {
      this.$emit("eventOnMinRange", val);
    },
    eventMaxRange(val) {
      this.$emit("eventOnMaxRange", val);
    },
    eventMinRangeChange(val) {
      this.$emit("eventOnMinRangeChange", val);
    },
    eventMaxRangeChange(val) {
      this.$emit("eventOnMaxRangeChange", val);
    },
    onUserSelectedExecutionTime() {
      this.$emit(
        "eventOnUserSelectedExecutionTime",
        this.selectedExecutionTimeAux,
      );
    },
  },
};
</script>

<style scoped>
.col-fixed {
  flex: 0 0 auto;
  width: 10rem;
}

.toggle__button {
  vertical-align: middle !important;
  user-select: none;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.toggle__button input[type="checkbox"] {
  opacity: 0;
  position: absolute;
  width: 1px;
  height: 1px;
}

.toggle__button .toggle__switch {
  display: inline-block;
  height: 0.8rem;
  border-radius: 6px;
  width: 1.1rem;
  background: var(--graylightbackground);
  /* box-shadow: inset 0 0 1px var(--graylightbackground); */
  position: relative;
  margin: 0;
  top: 0;
  left: 3px;
  transition: all 0.25s;
}

.toggle__button .toggle__switch::after,
.toggle__button .toggle__switch::before {
  content: "";
  position: absolute;
  display: block;
  height: 0.65rem;
  width: 0.65rem;
  border-radius: 50%;
  left: 1px;
  top: 1px;
  transform: translateX(0);
  transition: all 0.3s cubic-bezier(0.5, -0.6, 0.5, 1.6);
}

.toggle__button .toggle__switch::after {
  background: var(--background);
  border: 1px solid var(--darkbackground);
  /* box-shadow: 0 0 1px white; */
}

.toggle__button .toggle__switch::before {
  background: var(--background);
  border: 1px solid var(--darkbackground);
  /* box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1); */
  opacity: 0;
}

.active .toggle__switch {
  background: var(--dark-expo);
  /* box-shadow: inset 0 0 1px var(--graylightbackground); */
}

/* .active .toggle__switch::after,
.active .toggle__switch::before {
  transform: translateX(2px);
} */

.active .toggle__switch::after {
  left: 5px;
  background: var(--background);
  border: 1px solid var(--darkbackground);
  /* box-shadow: 0 0 1px var(--expo); */
}

@media (max-width: 1200px) {
  .table-data-controls td,
  tr {
    font-size: 0.7rem !important;
  }
}

@media (max-width: 1400px) {
  .table-data-controls td,
  tr {
    font-size: 0.8rem !important;
  }
}
</style>
